import { createSlice } from "@reduxjs/toolkit";

export const ticketSlice = createSlice({
  name: "ticket",
  initialState: {
    getTicketResult: false,
    getTicketLoading: false,
    getTicketError: false,
    addTicketResult: false,
    addTicketLoading: false,
    deleteTicketResult: false,
  },
  reducers: {
    ticketReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TICKET":
          return {
            ...state,
            getTicketResult: payload.data,
            getTicketLoading: payload.loading,
            getTicketError: payload.error,
          };
        case "ADD_TICKET":
          return {
            ...state,
            addTicketResult: payload.data,
            addTicketLoading: payload.loading,
          };
        case "DELETE_TICKET":
          return {
            ...state,
            deleteTicketResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { ticketReducers } = ticketSlice.actions;

export default ticketSlice.reducer;
